export const contacts = {
  address: "155-18th st. (Unit B), Brandon, MB Canada",
  email: "multicookbrandon@gmail.com",
  phone: "(204) 717-7707",
  phoneCall: "+12047177707",
  fb: "https://www.facebook.com/profile.php?id=61566939935394&mibextid=ZbWKwL",
  ig: "https://www.instagram.com/multicookbrandon?igsh=MXJ5dXh5dmthcnRqbg==",
};
